export default {
    1: '操作失败, 您没有此权限',
    2: '企业无权限',
    3: '企业无权限',
    504: '请求超时',
    10202: '您已经举报过了，请耐心等待审核!',
    10203: '您要举报的资源已经不存在！',
    100316: '直播已结束',
    100315: '开始时间小于当前, 不允许发布',
    100034: '直播讲师超出最大人数限制',
    100313: '第三方直播不存在',
    40208: '您已经评过分了!',
    40324: '直播讲师无法删除',
    100321: '直播云请求失败',
    100326: '直播不允许此操作',
    10138: '没有权限',
    900000: '验证失败, 请重试',
    900001: '属性值必填',
    900002: '格式错误',
    900003: '文件大小超出限制',
    900004: '文件类型不支持',
    900005: '该资源已不存在',
    900008: '您好，您的操作过于频繁，请稍后再试',
    900009: '您好，您今日操作过于频繁，请明日再来吧',
    20106: '手机号码已被使用，请重新输入',
    20105: '邮箱已被使用，请重新输入',
    20159: '任务已撤销或已结束，无法催学',
    990001: '上传失败，图片大小不能大于5M',
    910001: '数据类型错误',
    910002: '超过长度限制',
    910003: '必填字段',
    90901: '您的账号已在另一台设备或浏览器登陆，请重新登陆',
    90902: '您的账号已在另一台设备登陆，请重新登陆',
    20138: '一次性验证码过期，可能已经绑定过邮箱，请重新绑定邮箱。',
    30142: '考试越权访问',
    30148: '考试必须通过，才能查看详情',
    21901: '已达到最大添加上限',
    21902: '无权操作该收货地址',
    10134: '短信发送失败',
    10142: '短信验证码接收次数已达上限，请过1小时后再试',
    20146: '请先添加手机或邮箱',
    20147: '邮箱验证码过期',
    20149: '手机号为空',
    90903: '账户登录频次过多已被限制，请稍后登录',
    20150: '邮箱为空',
    201502: '文件不能为空',
    21903: '文件服务异常,请重试',
    21904: '文件上传异常',
    900901: '企业无权限',
    900902: '未购买此课程',
    900903: '知学荟企业配置为空',
    900904: '回调接口配置为空',
    900905: '回调接口返回结果为空',
    900906: '回调接口返回的信息是失败',
    900907: '未购买此课程',
    900908: '注册接口参数传递有误!',
    900909: '注册接口返回为空!',
    900910: '注册接口调用失败!',
    900911: '该资源已不存在',
    900912: '企业无权限',
    40323: '配置推送内容和学员均为必填项',
    40217: '存在没有转换完成的附件',
    40210: '文件没有转换成功',
    40214: '截止时间不能小于当前时间',
    41102: '学习包推送内容数量或附件数量过多',
    86001: '活动id不存在',
    86002: '活动不在时间范围内',
    86003: '抽奖策略不能为空',
    86004: '没有抽奖次数',
    86005: '没有抽奖资格（免费抽奖次数用完或者没有足够积分）',
    86006: '收货信息不完整',
    86007: '奖品无法兑换',
    85001: '活动被使用，不能删除',
    85002: '活动发布状态不能删除',
    85003: '活动不存在',
    85004: '奖项数量不对',
    85005: '奖项概率和需要等于1',
    85006: '至少要有一个谢谢参与',
    85007: '该抽奖活动不是已发布状态',
    85008: '抽奖活动已发布状态不能撤销',
    85009: '已有抽奖活动投放积分商城，请先取消其他活动投放',
    85010: '奖项数量小于抽奖人数',
    85011: '奖品已经派发完了',
    85012: '中奖人数非法',
    85013: '活动发布过一次后不允许修改活动样式',
    86008: '活动已经结束，不允许再修改',
    86009: '受众项不能为空',
    86010: '抽奖人数不足',
    86011: '活动已经结束,不允许修改',
    86012: '该资源已不存在',
    86013: '奖项不能删除',
    86014: '奖项信息未填写',
    86015: '您不在活动参与人范围内，无权参与活动',
    86016: '您已经扫码成功参与该活动了',
    86017: '您不属于该活动的公司成员，无权参与活动',
    40109: '必须有一个必修内容才能发布',
    60201: '您已不是讲师或者您的讲师身份被禁用',
    34008: '该考卷已被管理员重置',
    39011: '考试记录参数缺失,如有疑问，请联系管理员!',
    39012: '考试结束后才能查看试卷,如有疑问,请联系管理员!',
    39013: '考试合格后才能查看试卷,如有疑问，请联系管理员!',
    70101: '有人关注，不能删除',
    70102: '有人分享，不能删除',
    70103: '有人讨论，不能删除',
    70104: '该内容已经关闭，不能参与讨论',
    70105: '该内容已关闭',
    70106: '该内容已激活',
    70107: '该内容已加精',
    70108: '该内容已取消加精',
    70109: '该内容已置顶',
    70110: '该内容已取消置顶',
    70111: '该内容已不存在',
    70118: '该内容已经被编辑,无法进行审核',
    70119: '该内容已经被举报,无法进行编辑',
    70120: '该问题已经存在,换个标题再发布吧',
    70201: '讨论有人回复，不能删除',
    70202: '该讨论已加精',
    70203: '该讨论已取消加精',
    70204: '该讨论已置顶',
    70205: '该讨论已取消置顶',
    70206: '该评论已不存在',
    70301: '您所在的组织没有专家资质配置',
    70302: '您已经提交专家申请，请勿重复提交',
    70303: '您已经是专家身份，不允许再次申请',
    70304: '您不是专家身份',
    70305: '您的话题更改申请正在审核中，不允许再次申请',
    70306: '您的专家身份已被冻结',
    70307: '该专家身份已被冻结，无法查看详情',
    70401: '您已经举报该内容，管理员正在审核中，请勿重复举报',
    70402: '您要举报的资源已经不存在！',
    70502: '已被审核过了',
    70503: '审核资源不存在',
    70999: '操作过于频繁，请稍候再试',
    70899: '无删除权限',
    70122: '该内容已被编辑，无法进行审核',
    71001: '不能重复订阅',
    71002: '专家不存在',
    71004: '用户积分不足',
    71005: '查询用户积分错误',
    13001: '查询系统规则配置错误',
    13002: '系统配置打赏功能关闭',
    13003: '不能重复打赏',
    13004: '打赏积分不合法',
    13005: '用户积分不足',
    13006: '用户积分不足',
    900920: '资源不存在',
    70207: '暂不支持发表言论',
    60131: '该班级已经结项',
    60139: '该班级已经撤销',
    64104: '班级不存在',
    701011: '额度不足，分配失败',
    701012: '额度不足，打赏失败',
    701013: '额度不足，专栏订阅失败',
    700404: '该纷享号已关注，请勿重复关注',
    700303: '邀请码不存在',
    700501: '专栏不存在啊',
    700502: '该专栏已被订阅，无法删除',
    700307: '您只能删除自己创建的专栏',
    700402: '该内容已被其他专栏绑定',
    700503: '无权限更新专栏',
    700504: '无权限删除专栏',
    20161: '不是上下级关系',
};
